module.exports = __webpack_public_path__ + "static/media/layerTween.680bd0d0.svg";